import { WorkoutsState, InitialState, ModuleAction, Types } from './club-injuries.model';

export function WorkoutsReducer(s: WorkoutsState = InitialState, a: ModuleAction): WorkoutsState {
  if (!a) { return s; }
  switch (a.type) {
    case Types.UpdateState: return { ...s, ...a.payload };
    default: return s;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/store/club-injuries.reducer.ts